<template>
  <div class="d-flex align-center flex-wrap">
    <div v-if="chips.length" class="d-flex flex-wrap align-center mr-2">
      <template v-for="chip in chips">
        <v-chip
          :key="chip.key + String(chip.value)"
          medium
          class="mr-1 mb-1"
          close
          @click:close="removeFilter(chip.key)"
        >
          {{ $i18n.translate(chip.label) }}: {{ chip.text }}
        </v-chip>
      </template>
    </div>
    <TableFilters
      v-model="filters"
      :schema="schema"
      @apply="onApplyFilters"
      :applyOnChange="applyOnChange"
      ref="tableFilters"
      :menuLabel="menuLabel"
      :title="title"
    />
  </div>
</template>

<script>
import TableFilters from "./TableFilters.vue";
export default {
  components: { TableFilters },
  name: "AdvancedTableFilters",
  props: {
    value: { type: Object, default: () => ({}) },

    schema: { type: Array, required: true },

    title: { type: String, default: "Advanced Search" },
    menuLabel: { type: String, default: "Advanced Search" },

    applyOnChange: { type: Boolean, default: false }
  },

  data() {
    return {
      chips: []
    };
  },

  computed: {
    filters: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },

  created() {},

  watch: {},

  methods: {
    async onApplyFilters({ filters, chips }) {
      this.chips = chips;
      this.$emit("apply", { filters: filters });
    },
    removeFilter(key) {
      this.$refs.tableFilters.removeFilter(key);
    }
  }
};
</script>
